import { generateApiActionTypes } from 'utils/actions/generateActionTypes'
import { ENDPOINTS } from 'utils/api/callApi'
import { IShipperLanesParams, SHIPPER_LANE_STATUS } from './types'

export const FETCH_SHIPPER_LANES_ACTIONS = generateApiActionTypes('FETCH_SHIPPER_LANES')

export const fetchShipperLanes = (params: IShipperLanesParams) => {
  return {
    payload: {
      callApi: true,
      requestData: {
        endpoint: ENDPOINTS.shipperLanes,
        method: 'GET',
        params,
      },
      actionTypes: Object.keys(FETCH_SHIPPER_LANES_ACTIONS),
    },
    type: '',
  }
}

export enum FETCH_SHIPPER_LANE_COUNTS_ACTIONS {
  FETCH_SHIPPER_LANE_COUNTS_REQUEST = 'FETCH_SHIPPER_LANE_COUNTS_REQUEST',
  FETCH_SHIPPER_LANE_COUNTS_SUCCESS = 'FETCH_SHIPPER_LANE_COUNTS_SUCCESS',
  FETCH_SHIPPER_LANE_COUNTS_FAILURE = 'FETCH_SHIPPER_LANE_COUNTS_FAILURE',
}
export const fetchShipperLanesCount = (params: IShipperLanesParams) => {
  const filters = Object.keys(SHIPPER_LANE_STATUS).map(status => ({
    ...params.filters,
    activeStatus: status.toLowerCase(),
  }))
  return {
    payload: {
      callApi: true,
      requestData: {
        endpoint: ENDPOINTS.shipperLanes,
        group: 'count',
        method: 'POST',
        body: { filters },
      },
      actionTypes: Object.keys(FETCH_SHIPPER_LANE_COUNTS_ACTIONS),
    },
    type: '',
  }
}
